export default "__VITE_ASSET__CUAFvLUl__"